import PropTypes from 'prop-types';
import { PDP_FILTER_TYPES } from 'commons/constants';

export const materialPropType = PropTypes.shape({
  materialId: PropTypes.number,
  label: PropTypes.string,
  image: PropTypes.string,
  upholsteryOptionId: PropTypes.number,
  description: PropTypes.string,
  groupName: PropTypes.string,
  tier: PropTypes.number,
  color: PropTypes.string,
  popular: PropTypes.bool,
  pet_friendly: PropTypes.number,
  performance_fabric: PropTypes.number,
  sustainable_fabric: PropTypes.number,
  sku: PropTypes.string,
});

export const basicDetailsPropType = PropTypes.shape({
  id: PropTypes.number,
  additional_attributes: PropTypes.object,
  attributes: PropTypes.arrayOf(PropTypes.object),
  attributes_min: PropTypes.shape({
    dimensions: PropTypes.string,
    urlKey: PropTypes.string,
  }),
  category_ids: PropTypes.arrayOf(PropTypes.number),
  clearance_stock: PropTypes.object,
  custom_properties: PropTypes.object,
  customer_photos_min: PropTypes.shape({
    photos: PropTypes.arrayOf(PropTypes.object),
    totalPhotos: PropTypes.number,
  }),
  customer_reviews: PropTypes.shape({
    reviews: PropTypes.arrayOf(PropTypes.object),
    totalReviews: PropTypes.number,
    averageRating: PropTypes.number,
  }),
  difficulty: PropTypes.string,
  efg_flag: PropTypes.number,
  is_external: PropTypes.number,
  hero_images: PropTypes.arrayOf(PropTypes.object),
  layout_widgets: PropTypes.arrayOf(PropTypes.object),
  meta: PropTypes.shape({
    customer: PropTypes.object,
    collectionSlug: PropTypes.string,
    eligible_protection_planids: PropTypes.arrayOf(PropTypes.number),
    price: PropTypes.object,
    promotion: PropTypes.object,
    reviews: PropTypes.object,
    similar_products: PropTypes.arrayOf(PropTypes.object),
  }),
  name: PropTypes.string,
  sku: PropTypes.string,
  stock: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.shape({
    name: PropTypes.string,
  }),
  variation_photos_count: PropTypes.object,
});

export const productImageUrls = PropTypes.shape({
  transparent_config_image: PropTypes.string,
  config_image: PropTypes.string,
  transparent_hero_image: PropTypes.string,
  transparent_config_image_ts: PropTypes.string,
  transparent_hero_image_ts: PropTypes.string,
});

export const productFilterTypes = PropTypes.shape({
  [PDP_FILTER_TYPES.ALL]: PropTypes.number,
  [PDP_FILTER_TYPES.POPULAR]: PropTypes.number,
  [PDP_FILTER_TYPES.SAFEGUARD]: PropTypes.number,
  [PDP_FILTER_TYPES.PETFRIENDLY]: PropTypes.number,
  [PDP_FILTER_TYPES.VELVET]: PropTypes.number,
  [PDP_FILTER_TYPES.SUSTAINABLE]: PropTypes.number,
});
